import { gql } from '@apollo/client';

export const UPLOAD_IMAGE_FILE_DOCUMENT = gql`
    mutation uploadImageFileDocument(
        $externalId: String!,
        $file1: Upload!,
        $file2: Upload,
        $file3: Upload,
        $file4: Upload,
        $file5: Upload,
        $file6: Upload,
        $file7: Upload,
        $file8: Upload,
        $file9: Upload,
        $file10: Upload,
    ){
        uploadImageFileDocument(
            externalId: $externalId,
            imageFile0: $file1,
            imageFile1: $file2,
            imageFile2: $file3,
            imageFile3: $file4,
            imageFile4: $file5,
            imageFile5: $file6,
            imageFile6: $file7,
            imageFile7: $file8,
            imageFile8: $file9,
            imageFile9: $file10
        ) {
            id
            fileName
            message
            publicId
        }
    }
`;

export const UPLOAD_PDF_DOCUMENT = gql`
    mutation UploadPDFDocument(
        $externalId: String!,
        $pdf: Upload!,
    ){
        uploadPDFDocument(
            externalId: $externalId
            pdf: $pdf
        ) {
            id
            fileName
            message
            publicId
        }
    }
`;


export const SUBMIT_FORM_INPUT = gql`
    mutation submitFormInput(
        $externalId: String!,
        $corporatePublicId: String,
        $personalPublicId: String,
        $planId: String!,
        $corporateName: String,
        $corporateNumber: String,
        $corporatePostalCode: String,
        $corporatePrefecture: String,
        $corporateCity: String,
        $corporateStreet: String,
        $corporateBuilding: String,
        $representativeLastName: String,
        $representativeFirstName: String,
        $personalLastName: String,
        $personalFirstName: String,
        $personalLastNameKana: String,
        $personalFirstNameKana: String,
        $personalBirthday: String,
        $personalPostalCode: String,
        $personalPrefecture: String,
        $personalCity: String,
        $personalStreet: String,
        $personalBuilding: String,
        $personalGender: String,
        $personalPhone: String,
        $personalEmail: String
    ) {
        submitFormInput(
            externalId: $externalId
            corporatePublicId: $corporatePublicId
            personalPublicId: $personalPublicId
            planId: $planId
            corporateName: $corporateName
            corporateNumber: $corporateNumber
            corporatePostalCode: $corporatePostalCode
            corporatePrefecture: $corporatePrefecture
            corporateCity: $corporateCity
            corporateStreet: $corporateStreet
            corporateBuilding: $corporateBuilding
            representativeLastName: $representativeLastName
            representativeFirstName: $representativeFirstName
            personalLastName: $personalLastName
            personalFirstName: $personalFirstName
            personalLastNameKana: $personalLastNameKana
            personalFirstNameKana: $personalFirstNameKana
            personalBirthday: $personalBirthday
            personalPostalCode: $personalPostalCode
            personalPrefecture: $personalPrefecture
            personalCity: $personalCity
            personalStreet: $personalStreet
            personalBuilding: $personalBuilding
            personalGender: $personalGender
            personalPhone: $personalPhone
            personalEmail: $personalEmail
        )
    }
`;

export const CORPORATE_NUMBER_VERIFICATION = gql`
    mutation CorporateNumberVerification(
        $externalId: String!,
    ) {
        corporateNumberVerification(
            externalId: $externalId
        )
    }
`;

export const SEND_ENTRY_EMAIL = gql`
    mutation SendEntryEmail(
        $name: String!,
        $birthday: String!,
        $submissionDate: String!,
        $externalId: String!,
        $email: String!
    ) {
        sendAcceptedEmail(
            name: $name,
            birthday: $birthday,
            submissionDate: $submissionDate,
            externalId: $externalId,
            email: $email
        )
    }
`
